module.exports = __webpack_public_path__ + "static/img/examinedetailYD.35807fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examinedetailYD.png
// module id = oXyN
// module chunks = 6